import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import { Toaster } from 'react-hot-toast';
import Sidebar from './components/Sidebar';
import AdditiveModel from './components/CFProjection/AdditiveModel/AdditiveModel';
import MultiplicativeModel from './components/CFProjection/MultiplicativeModel/MultiplicativeModel';
import HomePage from './components/HomePage';
import PythonPlayground from './components/PythonPlayground';
import ContactPage from './components/ContactPage';
import TableList from './components/TableList';
import MissingImputation from './components/DataQuality/MissingImputation';
import MissingRate from './components/DataQuality/MissingRate';
import ExpertCut from './components/Discretization/ExpertCut';
import IsotonicRegression from './components/Discretization/IsotonicRegression';
import MonotonicLightGBM from './components/Discretization/MonotonicLightGBM';
import MonotonicOptimalBinning from './components/Discretization/MonotonicOptimalBinning';
import QuantileCut from './components/Discretization/QuantileCut';
import IQR from './components/ExtremesValues/IQR';
import CART from './components/RiskDiff/CART';
import PerformanceTesting from './components/RiskDiff/PerformanceTesting/PerformanceTesting';
import Sampling from './components/RiskDiff/Sampling';
import ZScore from './components/ExtremesValues/ZScore';
import IsolationForest from './components/ExtremesValues/IsolationForest';
import { SecurityProvider } from './context/SecurityContext';
import MRPCashflows from './components/MRP/Cashflows/MRPCashflows';
import MRPNumbers from './components/MRP/Numbers/MRPNumbers';
import LRA from './components/RiskQuantification/LRA/LRA';
import MoCC from './components/RiskQuantification/MoCC/MoCC';
import DwtQuantification from './components/RiskQuantification/MoCDownturn/DwtQuantification/DwtQuantification';
import DwtIdentification from './components/RiskQuantification/MoCDownturn/DwtIdentification/DwtIdentification';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#667eea' },
    background: { default: '#f5f7fa' },
  },
});

function App() {
  console.log('App rendering, routes include /isolation-forest');
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SecurityProvider>
        <Router>
          <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <Sidebar />
            <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default' }}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/python-playground" element={<PythonPlayground />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/data" element={<TableList />} />
                                <Route path="/missing-rate" element={<MissingRate />} />
                <Route path="/missing-imputation" element={<MissingImputation />} />
                <Route path="/expert-cut" element={<ExpertCut />} />
                <Route path="/isotonic-regression" element={<IsotonicRegression />} />
                <Route path="/monotonic-lightgbm" element={<MonotonicLightGBM />} />
                <Route path="/monotonic-binning" element={<MonotonicOptimalBinning />} />
                <Route path="/quantile-cut" element={<QuantileCut />} />
                <Route path="/iqr" element={<IQR />} />
                <Route path="/cart" element={<CART />} />
                <Route path="/additive-projection" element={<AdditiveModel />} />
                <Route path="/multiplicative-projection" element={<MultiplicativeModel />} />
                <Route path="/mrp-cashflows" element={<MRPCashflows />} />
                <Route path="/mrp-numbers" element={<MRPNumbers />} />
                <Route path="/performance-testing" element={<PerformanceTesting />} />
                <Route path="/mrp-cashflows\" element={<MRPCashflows />} />
                <Route path="/lra" element={<LRA />} />
                <Route path="/moc-c" element={<MoCC />} />
                <Route path="/dwt-quantification" element={<DwtQuantification />} />
                <Route path="/dwt-identification" element={<DwtIdentification />} />
        <Route path="/sampling" element={<Sampling />} />
        <Route path="/zscore" element={<ZScore />} />
        <Route path="/isolation-forest" element={<IsolationForest />} />
              </Routes>
            </Box>
          </Box>
          <Toaster position="top-right" />
        </Router>
      </SecurityProvider>
    </ThemeProvider>
  );
}

export default App;
